
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiTipiOperazioniGrid extends Serenity.EntityGrid<ApiTipiOperazioniRow, any> {
        protected getColumnsKey() { return ApiTipiOperazioniColumns.columnsKey; }
        protected getDialogType() { return ApiTipiOperazioniDialog; }
        protected getIdProperty() { return ApiTipiOperazioniRow.idProperty; }
        protected getInsertPermission() { return ApiTipiOperazioniRow.insertPermission; }
        protected getLocalTextPrefix() { return ApiTipiOperazioniRow.localTextPrefix; }
        protected getService() { return ApiTipiOperazioniService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}